import { usePrevious } from "../../helpers"

export function usePrevSelected(selected, articles) {
  const prevSelected = usePrevious(selected)
  return prevSelected || articles[0]
}